export default "__VITE_ASSET__BH8O6d8G__"